import styled from 'styled-components';

import { DESKTOP_MIN_WIDTH } from 'constants';
import FormTransactionDetails from '../FormTransactionDetails';

const OrderReceiptDetails = ({ handleOnBackToHome }) => {
  return (
    <OrderReceiptDetailsStyled>
      <FormTransactionDetails
        isOpen={true}
        onClose={handleOnBackToHome}
        isReceipt={true}
      />
    </OrderReceiptDetailsStyled>
  );
};

const OrderReceiptDetailsStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: 0px;
  padding-inline: 0px;
  padding-bottom: 140px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    display: block;
    width: 437px;
    margin-top: -8px;
    margin-inline: auto;
    padding-inline: 0px;
    padding-bottom: unset;
  }
`;

export default OrderReceiptDetails;
